import company from "./company"

export const DefaultTimezone =
  company === "catwamego" || company === "sysco"
    ? "America/Chicago"
    : "America/New_York"
